//=====================================================
//　G002：治療メニュー選択
//=====================================================
import { useState, useLayoutEffect, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ContentsBox } from "../../common/ContentsBox";
import { BtnSubmit } from "../../common/BtnSubmit";
import { BtnReturn } from "../../common/BtnReturn";
import { ReservationFlow, ProcessName } from "../../common/ReservationFlow";
import { CtxClinicInfo, CtxClinicSystemInfo, CtxNewReservation, CtxSystemErr } from "../../utils/Contexts";
import { ContentsTitle } from "../../common/ContentsTitle";
import { getApiData } from "../../utils/CallApi";
import { AxiosResponse } from "axios";
import { MsgBoxErr } from "../../common/MsgBoxErr";
import { IFDataNewReservation } from "../../utils/UseNewReservation";
import { ConstMsg } from "../../utils/ConstMsg";
import { LoadingBox } from "../../common/LoadingBox";
import { useAuth } from "../../utils/UseAuth";

interface IFG002Menu {
    id: string,
    name: string,
    description: string,
    time: number
}

export function G002(){

    const [menu, setMenu] = useState<IFG002Menu[]>();
    const [selectMenuIdx, setSelectMenuIdx] = useState(-1);
    const [errmess, setErrmess] = useState("");
    const [loadingDone, setLoadingDone] = useState(false);

    const history = useHistory();
    const cserr = useContext(CtxSystemErr);
    const cnr = useContext(CtxNewReservation);
    const ccsi = useContext(CtxClinicSystemInfo);
    const cci = useContext(CtxClinicInfo);
    const ua = useAuth();

    // タイトル追加処理
    useEffect(function(){
        if(cci.data.name){
            document.title = cci.data.name + " | Web予約 - 治療メニュー選択";
        }else{
            document.title = process.env.REACT_APP_DEFAULT_CLININC_NAME + " | Web予約 - 治療メニュー選択";
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    //メニュー選択処理
    function clickMenu(idx: number){
        setSelectMenuIdx(idx);
    }
    
    //次へボタンクリック処理
    function clickNext(){
        if (menu && selectMenuIdx !== -1){
            setErrmess("");
            let param:IFDataNewReservation = {menu: menu[selectMenuIdx].name};
            param.menutime = menu[selectMenuIdx].time;
            param.medicalTypeId = menu[selectMenuIdx].id;
            cnr.data.date = undefined;
            cnr.update(param);
            history.push("/reservation/date/monthly");
        } else {
            setErrmess(ConstMsg.EG0020001);
        }
    }

    useLayoutEffect(function(){
        // マウントフラグ
        let isMounted = true;

        // アンマウント時はstate(history)を更新しないようにする
        if(isMounted){
            // 完了データの場合、マイページ、トップ画面へ遷移
            if(cnr.data.done){
                if(ua.isLoggedIn()){
                    history.push('/mypage');
                } else {
                    history.push('/');
                }
            }
        }
        
        const tmpMenu:IFG002Menu[] = [];
        const clinicId = cci.data.id;
        let apiUrl = `/c/${clinicId}/medicaltypes`;
        getApiData(apiUrl, {}, function(res:AxiosResponse<any>) {
            // アンマウント時はstateを更新しないようにする
            if(isMounted){
                if (res?.data) {
                    if (res.status === 200) {
                        setErrmess("");
                        res.data.forEach(function(val: any){
                            tmpMenu.push({id: val.id, name: val.name, description: val.description, time: val.time});
                        });
                        setMenu(tmpMenu);
                    } else if (res.status === 403 || res.status === 404 || res.status >= 500) {
                        cserr.setErrmess(res.data.message);
                    } else {
                        cserr.setErrmess(ConstMsg.EG9990001);
                    }
                } else {
                    cserr.setErrmess(ConstMsg.EG0020002);
                }
                setLoadingDone(true);
            }
        });

        // cleanup関数(Unmount時の処理)
        return () => {
            // マウントオフ
            isMounted = false;
        }
        // エラーメッセージを更新するため、cserrは第2引数から除外する
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[cci.data.id]
    );

    return (
        <>
            <ReservationFlow currentProcess={ProcessName.Menu}/>
            <ContentsBox>
                <ContentsTitle title="治療メニューを選択してください" />
                {errmess && <MsgBoxErr text={errmess} />}
                <LoadingBox overlay={false} loadingDone={loadingDone}>
                    <ul className="treatment-menu-list">
                        {menu?.map(function(val, idx){
                            return (
                                <li key={idx} onClick={function(){clickMenu(idx)}} className={selectMenuIdx === idx ? "is-selected" : ""}>
                                    <div className="treatment-menu-list-circle"></div>
                                    <div className="treatment-menu-title text-l">{val.name}</div>
                                    {(ccsi.data.display.medicalCareTime && val.time !== undefined) &&
                                        <div className="treatment-menu-time text-s"><span className="icon-clock"></span>診療時間：{val.time}分</div>
                                    }
                                    {val.description &&
                                        <div className="treatment-menu-text text-multiline">{val.description}</div>
                                    }
                                </li>
                            )
                        })}
                    </ul>
                    <BtnSubmit title="次へ" onClick={clickNext} />
                </LoadingBox>
            </ContentsBox>
            <BtnReturn />
        </>
    )

}